<template>
	<svg mlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1200 1200">
		<defs>
			<pattern id="New_Pattern" data-name="New Pattern" width="12" height="12" patternUnits="userSpaceOnUse" viewBox="0 0 12 12">
				<rect class="cls-1" width="12" height="12"/>
				<circle class="cls-2" cx="12" cy="9" r="2"/>
				<circle class="cls-2" cx="6" cy="12" r="2"/>
				<circle class="cls-2" cy="9" r="2"/>
				<circle class="cls-2" cx="12" cy="3" r="2"/>
				<circle class="cls-2" cx="6" cy="6" r="2"/>
				<circle class="cls-2" cy="3" r="2"/>
				<circle class="cls-2" cx="6" r="2"/>
			</pattern>
		</defs>
		<g id="Background_elements" data-name="Background elements">
			<path class="cls-3" d="M876.41,595.49v496.24a65.66,65.66,0,0,1-65.66,65.66H425a65.66,65.66,0,0,1-65.66-65.66V107A65.67,65.67,0,0,1,425,41.34H810.75A65.67,65.67,0,0,1,876.41,107V595.49"/>
			<rect class="cls-4" x="488.92" y="15.42" width="257.9" height="64.39" rx="15.72" ry="15.72"/>
			<rect class="cls-4" x="405.91" y="149.31" width="423.93" height="207.6"/>
			<rect class="cls-4" x="429.63" y="525.61" width="565.57" height="19.53"/>
			<rect class="cls-4" x="429.63" y="576.97" width="565.57" height="19.53"/>
			<rect class="cls-4" x="429.63" y="628.32" width="565.57" height="19.53"/>
			<rect class="cls-4" x="429.63" y="679.68" width="565.57" height="19.53"/>
			<rect class="cls-4" x="429.63" y="731.04" width="565.57" height="19.53"/>
			<rect class="cls-4" x="429.63" y="782.4" width="565.57" height="19.53"/>
			<rect class="cls-4" x="429.63" y="833.76" width="565.57" height="19.53"/>
			<rect class="cls-4" x="429.63" y="885.12" width="565.57" height="19.53"/>
			<rect class="cls-4" x="540.74" y="974.2" width="267.06" height="19.53"/>
			<rect class="cls-4" x="540.74" y="1015.26" width="294.41" height="19.53"/>
			<rect class="cls-4" x="403.44" y="472.93" width="63.86" height="20.28"/>
			<rect class="cls-4" x="483.08" y="472.93" width="63.86" height="20.28"/>
			<rect class="cls-4" x="568.07" y="472.93" width="63.86" height="20.28"/>
			<circle class="cls-4" cx="475.67" cy="1001.8" r="42.45"/>
			<rect class="cls-5" x="429.63" y="394.62" width="525.91" height="41.69"/>
		</g>
		<g id="Vector">
			<path class="cls-6" d="M139.71,459.43c-2.83,4.11-7.73,36.26-3.81,56.23,5.63,4.83,27.68,21.55,27.68,21.55l-2.07-64Z"/>
			<path class="cls-6" d="M286.86,520c-10.14-26.85-17.74-77.59-20-100.25l-10.14-3.42c0,8.57,19.33,166.57-36,229.44,12.93.76,27.73.68,42,.21C270.65,604.66,283.67,536.44,286.86,520Z"/>
			<path class="cls-6" d="M328.36,582c-8,19.09-18,41.57-27.18,61.87,13.14-1,21.9-1.87,21.9-1.87l.77-11.56.79-4.51,3-3.27,1.54-4.36,2.69-21.77,2-26.11-5.49,11.76Z"/>
			<path class="cls-4" d="M330.83,1088.66l13.75-19,14.75,8.92V107A65.67,65.67,0,0,1,425,41.34H810.75A65.67,65.67,0,0,1,876.41,107v830.8c10.37-25.88,21.91-50.3,31.38-70.61V101.06A95.06,95.06,0,0,0,812.73,6H423A95.06,95.06,0,0,0,328,101.06V317.59c16,31.87,19.93,84.56,15.27,91.09a11.44,11.44,0,0,1-4.6,3.11h0c2.43,25.91,8,109.24,5.11,128.12-.72,4.75-4.39,15.05-9.69,28.28l0-.05c-1.78,28.64-4.15,48.55-5.39,52.4a8.75,8.75,0,0,1-.73,1.63v475.45a94.68,94.68,0,0,0,23.72,62.81l6.7-55.1Z"/>
			<path class="cls-4" d="M857.8,1137.5a65.42,65.42,0,0,1-47,19.89H425a65.52,65.52,0,0,1-51.22-24.6l-18.85,31.15A94.75,94.75,0,0,0,423,1192.68H812.73a94.63,94.63,0,0,0,55.61-18A288.17,288.17,0,0,1,857.8,1137.5Z"/>
			<path d="M175.54,629.41S93.93,908.11,93.93,913.76s227.78,191.79,232,191.79,21.75-34,21.75-39.91S293.46,1015,293.46,1015Z"/>
			<path class="cls-7" d="M161.51,473.2c-29.36-18.48-111.43-71.35-126.67-71.35-17.74,0-16.28,10.46-16.28,13.62s2.18,24.06,51.77,36.94c4.07,5,67.1,68.92,93.25,84.8"/>
			<path class="cls-7" d="M304.34,294c-9.4-17.12-21.36-29.05-36.49-33.23"/>
			<path class="cls-7" d="M305.78,633.7c12.31-2.88,21-7.15,22.9-13.16,1.24-3.85,3.61-23.76,5.39-52.4"/>
			<path class="cls-7" d="M223.12,267.49c-94,54.15-54.29,352.51-47.58,361.92,4.12,5.76,48.62,10.52,88.66,9"/>
			<polygon class="cls-8" points="61.11 436.3 2.12 397.84 34.37 380.01 91.91 416.22 61.11 436.3"/>
			<path class="cls-7" d="M266.9,419.78c2.22,22.66,9.82,73.4,20,100.25-4.66,24-30.27,158.33-30.27,158.33l18,23.28s65.86-139.86,69.19-161.73c2.87-18.88-2.68-102.21-5.11-128.12"/>
			<path class="cls-7" d="M278.58,303.79c5.55-6.36,12.16-10.29,19.94-10.46,40.17-.88,51.47,105.87,44.7,115.35s-78.33,16.71-86.46,7.68c-1.73-1.93-2.76-8.58-2.9-17.87"/>
			<path class="cls-7" d="M245.48,283.36c11.18-.06,22.37-2.3,22.37-6.54V215.54"/>
			<path class="cls-7" d="M223.12,244.4v23.09"/>
			<path class="cls-7" d="M223.12,244.4c-19.05-7.35-32.1-37.31-30.28-72.41"/>
			<path class="cls-7" d="M269.37,212c-.49,1.22-1,2.42-1.52,3.59"/>
			<path class="cls-7" d="M177,175c-5,0-30-6-30-23,0-7,4-15,4-23,0-7-3-15-3-25,0-17,17-25,26-25,17,0,21,12,48,12,16,0,23-4,32-4,28,0,32,35,32,39,0,17,23,18,23,36,0,13.31-11,28.46-22.54,34.41"/>
			<path class="cls-7" d="M269.5,191a10.5,10.5,0,0,1,0,21"/>
			<path class="cls-9" d="M1156.76,845.33c-37.49,0-41.48,40.22-66.85,40.22-9.79,0-12.5-10.33-12.5-20.11,0-16.67,26.93-78.55,29.19-118.29a44,44,0,0,1-8,.72c-17.74,0-32.13-10.31-32.13-23s14.39-23,32.13-23c.8,0,1.59,0,2.37.07-8.49-29.27-28.35-59.82-72-59.82-71.74,0-91.31,127.18-102.18,178.81-6.73,32-78.33,146.75-78.33,231.68,0,74.86,23,138.71,29,138.71h72.13c0-23,44.73-65.49,55.37-77.12,73.62-80.47,195-117.07,195-211.2C1200,882.29,1194.75,845.33,1156.76,845.33Z"/>
			<path class="cls-7" d="M207.9,182.67c0,4.07-.94,11.59-3.61,14.88"/>
			<path class="cls-7" d="M223.88,203.08c0,2.95-2.39,8.87-7.73,8.87"/>
			<ellipse cx="218.53" cy="182.91" rx="1.93" ry="3.24"/>
			<path d="M274.55,701.64l-18-23.28,7.46-39.1a273.72,273.72,0,0,1-88.51-9.85c5.36,44.32,81,503,81,503h43.78l.2-2.7L325.9,624.84c-3.2,2.3-10,5.24-19.69,7.9C289.94,669,274.55,701.64,274.55,701.64Z"/>
			<polyline class="cls-7" points="294.69 1132.37 294.69 1190.04 210.47 1190.04 271.29 1162.65 271.29 1130.45"/>
			<polyline class="cls-7" points="344.58 1069.64 393.92 1099.49 350.32 1171.54 358.37 1105.33 330.83 1088.66"/>
			<path d="M735.33,908.29c32.87,127.39,94.85,228.72,138.38,278.64-8.72-15.53-25.19-71-25.19-134.38,0-34.41,11.75-73.71,26.18-110.42-47.58-116.51-112.69-236-152.54-236-6.35,0-9.33,16.25-9.33,29.7a674.67,674.67,0,0,0,11.15,121c1.37,0,2.76-.09,4.17-.09,19.12,0,34.62,5.37,34.62,12s-15.18,11.88-34,12c.29,1.32.57,2.63.87,3.94,18.43.27,33.15,5.53,33.15,12C762.77,902.33,751,907.15,735.33,908.29Z"/>
			<path class="cls-7" d="M1029,642.06c-71.74,0-91.31,127.18-102.18,178.81-6.73,32-78.33,146.75-78.33,231.68"/>
		</g>
	</svg>
</template>

<script>
    import { Vue, Component } from "vue-property-decorator";

    @Component({})
    export default class HeroIllustration extends Vue{

	}
</script>

<style scoped>
 .cls-1,.cls-7{
	 fill:none;
 }
 .cls-2{
	 fill:#949494;
 }
 .cls-3,.cls-9{
	 fill:#fff;
 }
 .cls-4{
	 fill:#f3f3f3;
 }
 .cls-5{
	 fill:#e2e2e2;
 }
 .cls-6{
	 fill:url(#New_Pattern);
 }
 .cls-7,.cls-9{
	 stroke: #000;
	 stroke-linecap: round;
	 stroke-linejoin: round;
	 stroke-width: 3px;
 }
 .cls-8{
	 fill:#0f141e;
 }
</style>